import { LOGOUT_AUTH_USER, SET_AUTH_USER, SET_UPDATED_PASS } from "./constans";


const initialState = {};

const userReducers = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_USER:
      return { ...state, ...action.payload, userIsAuth: true }
    case LOGOUT_AUTH_USER:
      return initialState
    case SET_UPDATED_PASS:
      return { updatedPass: true }
    default:
      return state;
  }
};

export default userReducers;
